if (!customElements.get("search-template")) {
    customElements.define(
      "search-template",
      class SearchTemplate extends HTMLElement {
        constructor() {
          super();
          this.init();
        }
  
        init() {
          const type = this.getQueryParam('type')
          const tabItems = this.querySelectorAll(".search-tab-item");
          const searchForm = this.querySelector('.search-bar-form');
          const searchInput = searchForm.querySelector("input[name='type']")
          searchInput.value = type ?? 'product'
  
          tabItems.forEach((item, index) => {
            item.dataset.type == type &&  item.classList.add('active')
            item.onclick = () => {
              searchInput.value = item.dataset.type
              searchForm.submit()
            };
          });
        }
  
         getQueryParam(paramName) {
          const url = window.location.search;
          const regex = new RegExp('[?&]' + paramName + '=([^&#]*)');
          const results = regex.exec(url);
          return results === null ? null : decodeURIComponent(results[1]);
        }
      }
    );
  }
  